import { Box, Container, Paper, Typography } from "@mui/material";
import ClientCorousel from "../ClientCorousel";
import PartnerCorousel from "../PartnerCorousel";
import { designTokens } from "../../../theme/designTokens";

const { colors, borderRadius } = designTokens;

const PartnersSection = () => (
  <Box sx={{ py: designTokens.spacing.sectionPy, backgroundColor: colors.backgroundAlt }}>
    <Container maxWidth={designTokens.spacing.containerMax}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 5 },
          mb: 4,
          borderRadius: borderRadius.lg,
          border: `1px solid ${colors.border}`,
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 700, textAlign: "center", mb: 4 }}>
          Our Trusted Programs & Partnerships
        </Typography>
        <PartnerCorousel />
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 5 },
          borderRadius: borderRadius.lg,
          border: `1px solid ${colors.border}`,
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 700, textAlign: "center", mb: 4 }}>
          Our Featured Partners
        </Typography>
        <ClientCorousel />
      </Paper>
    </Container>
  </Box>
);

export default PartnersSection;
